import React from 'react'

import Wrapper from './Wrapper'
import { Button } from 'components/base'
import noConnection from 'assets/images/error-connection.svg'

const image = (
  <img src={noConnection} alt="no-connection" style={{ width: 564 }} />
)

export default function InAppNoConnection() {
  return (
    <Wrapper
      image={image}
      goBackButton={
        <div className="flexbox">
          <Button.Primary onClick={() => window.location.reload()}>
            Reload now
          </Button.Primary>
        </div>
      }
      title={"Couldn't connect to Slite"}
      subtitle={`You are not connected to internet`}
      children={'It seems you are offline, check your connection?'}
    />
  )
}
